import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Grid, InputAdornment } from "@material-ui/core";

import "./employerSection.css";

const EmployerSection = (props: any) => {
	const [employerSection, setEmployerSection] = useState({ ...props.employerSection });
	const [isPrintable, setIsPrintable] = useState(props.isPrintable);

	useEffect(() => {
		setEmployerSection(Object.assign({}, props.employerSection));
	}, [props.employerSection]);

	return (
		<div className="employer-section-container">
			<div className="employer-form-header" id="employer-form-header">
				Employer Completes this Section.
			</div>
			<div className="billing-division" id="billing-division">
				<span className="heading-label">Billing Division or Location: </span>
				<span className="textfield-container" id="textfield-container">
					<TextField
						className="text-field"
						id="text-field"
						name="billing_division"
						value={employerSection.billing_division}
						onChange={props.handleEnrollmentChange}
						style={{
							width: isPrintable ? "70%" : "80%",
							borderRadius: 50
						}}
					/>
				</span>
			</div>
			<div className="group-cycle-container" id="group-cycle-container">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 7 : 8}
						sm={isPrintable ? 7 : 8}
						md={isPrintable ? 7 : 8}
						lg={isPrintable ? 7 : 8}
						xl={isPrintable ? 7 : 8}
						className="sort-group"
					>
						<span className="heading-label">Sort Group/Code: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="sort_code"
								value={employerSection.sort_code}
								onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "65%" : "79%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 5 : 4}
						sm={isPrintable ? 5 : 4}
						md={isPrintable ? 5 : 4}
						lg={isPrintable ? 5 : 4}
						xl={isPrintable ? 5 : 4}
						className="payroll-cycle"
					>
						<span className="heading-label">Payroll Cycle: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="payroll_cycle"
								value={employerSection.payroll_cycle}
								onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "59%" : "65.5%",

									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="policy-container" id="policy-container">
				<span className="heading-label">Policy #(s): </span>
				<span className="textfield-container" id="textfield-container">
					<TextField
						className="text-field"
						id="text-field"
						name="policy"
						value={employerSection.policy}
						onChange={props.handleEnrollmentChange}
						style={{
							width: isPrintable ? "85.5%" : "90.3%",
							borderRadius: 50
						}}
					/>
				</span>
			</div>
			<div className="average-occupation-container" id="average-occupation-container">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 9 : 8}
						sm={isPrintable ? 9 : 8}
						md={isPrintable ? 9 : 8}
						lg={isPrintable ? 9 : 8}
						xl={isPrintable ? 9 : 8}
						className="average-hours"
					>
						<span className="heading-label">Average Hours Worked Per Week: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="average_hours"
								value={employerSection.average_hours}
								onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "9%" : "",
									borderRadius: 50
								}}
							/>
						</span>
						<span className="full-time-checkbox">
							<input
								type="checkbox"
								id="full-time"
								name="full_time"
								value="full_time"
								onChange={props.handleCheck}
								checked={employerSection.employment_status === "full_time" ? true : false}
							/>
							  <label htmlFor="full_time">Full-time</label>
						</span>
						<span className="part-time-checkbox">
							<input
								type="checkbox"
								id="part-time"
								name="part_time"
								value="part_time"
								onChange={props.handleCheck}
								checked={employerSection.employment_status === "part_time" ? true : false}
							/>
							  <label htmlFor="part_time">Part-time</label>
						</span>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 3 : 4}
						sm={isPrintable ? 3 : 4}
						md={isPrintable ? 3 : 4}
						lg={isPrintable ? 3 : 4}
						xl={isPrintable ? 3 : 4}
						className="occupation-container"
					>
						<span className="heading-label">Occupation: </span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="occupation"
								value={employerSection.occupation}
								onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "45%" : "69%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="earnings-container" id="earnings-container">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 10 : 8}
						sm={isPrintable ? 10 : 8}
						md={isPrintable ? 10 : 8}
						lg={isPrintable ? 10 : 8}
						xl={isPrintable ? 10 : 8}
						className="earnings-container"
					>
						<span className="heading-label">Earnings: </span>
						<span className="hourly-radio-field">
							<input
								type="checkbox"
								id="hourly"
								name="hourly"
								value="hourly"
								onChange={props.handleCheck}
								checked={employerSection.earning_status === "hourly" ? true : false}
							/>
							  <label htmlFor="hourly">Hourly</label>
						</span>
						<span className="weekly-radio-field">
							<input
								type="checkbox"
								id="weekly"
								name="weekly"
								value="weekly"
								onChange={props.handleCheck}
								checked={employerSection.earning_status === "weekly" ? true : false}
							/>
							  <label htmlFor="weekly">Weekly</label>
						</span>
						<span className="monthly-radio-field">
							<input
								type="checkbox"
								id="monthly"
								name="monthly"
								value="monthly"
								onChange={props.handleCheck}
								checked={employerSection.earning_status === "monthly" ? true : false}
							/>
							  <label htmlFor="monthly">Monthly</label>
						</span>
						<span className="yearly-radio-field">
							<input
								type="checkbox"
								id="yearly"
								name="yearly"
								value="yearly"
								onChange={props.handleCheck}
								checked={employerSection.earning_status === "yearly" ? true : false}
							/>
							  <label htmlFor="yearly">Yearly</label>
						</span>
						<span className="textfield-container" id="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="earnings"
								value={employerSection.earnings}
								onChange={props.handleEnrollmentChange}
								InputProps={{
									startAdornment: <InputAdornment position="start">$</InputAdornment>
								}}
								style={{
									width: "25%",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 5 : 4}
						sm={isPrintable ? 5 : 4}
						md={isPrintable ? 5 : 4}
						lg={isPrintable ? 5 : 4}
						xl={isPrintable ? 5 : 4}
						className="employment-container"
					>
						<span className="heading-label">Date of Employment: </span>
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="MM"
								name="month"
								value={employerSection?.date_of_employment?.month}
								onChange={props.handleEnrollmentDateChange}
								style={{
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="DD"
								name="day"
								value={employerSection?.date_of_employment?.day}
								onChange={props.handleEnrollmentDateChange}
								style={{
									marginLeft: "3px",
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="YYYY"
								name="year"
								value={employerSection?.date_of_employment?.year}
								onChange={props.handleEnrollmentDateChange}
								style={{
									marginLeft: "3px",
									width: isPrintable ? "40px" : "50px",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
			<div className="active-work-container" id="active-work-container">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 7 : 8}
						sm={isPrintable ? 7 : 8}
						md={isPrintable ? 7 : 8}
						lg={isPrintable ? 7 : 8}
						xl={isPrintable ? 7 : 8}
						className="active-work-sub-container"
					>
						<span className="heading-label">Actively at work? </span>
						<span className="active-work-yes-radio-field">
							<input
								type="checkbox"
								id="yes"
								name="yes"
								value="yes"
								onChange={props.handleCheck}
								checked={employerSection.active_work_status}
							/>
							  <label htmlFor="yes">Yes</label>
						</span>
						<span className="active-work-no-radio-field">
							<input
								type="checkbox"
								id="no"
								name="no"
								value="no"
								onChange={props.handleCheck}
								checked={employerSection.active_work_status === false ? true : false}
							/>
							  <label htmlFor="no">No</label>
						</span>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 5 : 4}
						sm={isPrintable ? 5 : 4}
						md={isPrintable ? 5 : 4}
						lg={isPrintable ? 5 : 4}
						xl={isPrintable ? 5 : 4}
						className="rehire-container"
					>
						<span className="heading-label">Date of Rehire: </span>
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="MM"
								name="month"
								value={employerSection?.date_of_rehire?.month}
								onChange={props.handleRehireDateChange}
								style={{
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="DD"
								name="day"
								value={employerSection?.date_of_rehire?.day}
								onChange={props.handleRehireDateChange}
								style={{
									marginLeft: "3px",
									width: "30px",
									borderRadius: 50
								}}
							/>
						</span>
						/
						<span className="textfield-container">
							<TextField
								className="date-field"
								id="text-field"
								placeholder="YYYY"
								name="year"
								value={employerSection?.date_of_rehire?.year}
								onChange={props.handleRehireDateChange}
								style={{
									marginLeft: "3px",
									width: "50px",
									borderRadius: 50
								}}
							/>
						</span>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default EmployerSection;
